import { Users } from "lucide-react";
import ConfirmDialog from "../shared/ConfirmDialog/ConfirmDialog";

const RemoveCollaboratorDialog = ({
  collaborator,
  isRemoving,
  onConfirm,
  onCancel,
}) => {
  if (!collaborator) return null;

  const isPending = collaborator.status === "PENDING";
  const displayName = collaborator.name || collaborator.email;

  const confirmLabel = isPending ? "Cancel Invitation" : "Remove";
  const loadingLabel = isPending ? "Canceling..." : "Removing...";

  return (
    <ConfirmDialog
      open={!!collaborator}
      title={isPending ? "Cancel Invitation?" : "Remove Collaborator?"}
      icon={
        <div className="w-12 h-12 rounded-full bg-fill-red-100 dark:bg-fill-red-900/30 flex items-center justify-center">
          <Users className="w-6 h-6 text-ink-red-600 dark:text-ink-red-400" />
        </div>
      }
      confirmLabel={confirmLabel}
      loadingLabel={loadingLabel}
      isLoading={isRemoving}
      onCancel={onCancel}
      onConfirm={onConfirm}
      divider
    >
      {isPending ? (
        <>
          Are you sure you want to cancel the invitation for{" "}
          <span className="font-semibold">{collaborator.email}</span>?
        </>
      ) : (
        <>
          Are you sure you want to remove{" "}
          <span className="font-semibold">{displayName}</span> from this
          spectra? They will lose access to all sparks and files.
        </>
      )}
    </ConfirmDialog>
  );
};

export default RemoveCollaboratorDialog;
